export default __webpack_public_path__ + "static/media/helmet1.a9b8b2b9.png";